<template>
  <section class="userProfile" :style="{ backgroundImage: `url(${this.$store.state.template.profileConfig.bg})` }">
    <Header v-show="profileConfig.showHeader" />
    <div class="userProfile-wrapper" @click="showImageCropper = false">
      <div class="userProfile-head-container" v-html="profileConfig.containerHead"></div>
      <div ref="userTag" class="user-panel">
        <div id="userPanelTop" class="user-panel-top-container" v-if="this.$store.state.template.userProfile.topImage">
          <img :src="`${this.$store.state.template.userProfile.topImage}`" />
        </div>
        <div id="userPanelTop" class="user-panel-top-container" v-else>
          <div v-if="this.$store.state.template.userProfile.topLeftImage">
            <img :src="`${this.$store.state.template.userProfile.topLeftImage}`" />
          </div>
          <div style="margin-left: 50px" v-if="this.$store.state.template.userProfile.topRightImage">
            <img :src="`${this.$store.state.template.userProfile.topRightImage}`" />
          </div>
        </div>
        <div class="user-image-and-fields">
          <div id="userImageWrapper" class="user-image-wrapper" v-if="profileConfig.field.image">
            <img id="userPicture" class="userProfile-user-picture-img" :src="user.picture" />
            <div class="avatar-list-container" v-if="openAvatarList" @click.prevent="openAvatarList = !openAvatarList">
              <span><i class="fas fa-times-circle" style="cursor: pointer"></i></span>
              <div class="avatar-list">
                <iframe class="avatarCreatorIframe" src="https://proto-assets.s3.amazonaws.com/avatar/rpmAvatarPhoto.html" allow="camera *; microphone *" frameborder="0" v-if="openAvatarList"></iframe>
                <!-- <iframe class="avatarCreatorIframe" src="http://127.0.0.1:5501/rpmAvatarPhoto.html" allow="camera *; microphone *" frameborder="0" v-if="openAvatarList"></iframe> -->

                <!-- <img v-for="(avatar,k) in $store.state.template.userProfile.avatarList" :key="k" :src="avatar" @click.prevent="user.picture=avatar"> -->
              </div>
            </div>
            <div class="user-image-uploader" v-if="isEditing">
              <input ref="fileInput" style="display: none" type="file" @change="imgFilePicked" />
              <div :title="$t('userProfile.buttons.choosePhoto')" id="chose-photo-btn" class="image-uploader-chose-file-btn" v-if="showImgBtns" @click="$refs.fileInput.click()"><i class="fas fa-camera"></i></div>
              <div
                :title="$t('userProfile.buttons.chooseAvatar')"
                id="chose-avatar-btn"
                class="image-uploader-chose-avatar-btn"
                v-if="showImgBtns && $store.state.template.userProfile.avatarList.length"
                @click.prevent="openAvatarList = !openAvatarList">
                <i class="fas fa-user-astronaut"></i>
              </div>

              <div class="image-uploader-cancel-btn" v-if="!showImgBtns && !showProgressBar" @click="onCancel">X</div>
              <div class="image-uploader-ok-btn" v-if="!showImgBtns && !showProgressBar" @click="uploadImage">OK</div>
              <div class="progressbar-container" v-if="showProgressBar">
                <div class="progressbar" :style="{ width: barWidth }"></div>
              </div>
            </div>
          </div>
          <div class="user-fields-wrapper">
            <!-- EDIT PROFILE BUTTON -->
            <button class="user-profile-btn edit-profile-btn" v-if="!isEditing" @click="startEdit">
              <i class="fas fa-edit"></i>
            </button>

            <!-- GO TO REGISTER BTN-->
            <!-- <router-link :to="{name:'UserProfileRegister'}" class="edit-register-btn" v-if="accessConfig.publicSignIn">Ver todo cadastro</router-link> -->

            <!-- USER TAG DOWNLOAD -->
            <button id="usertagDownloadBtn" class="panel-usertag-download-btn" v-if="$store.state.template.userProfile.enableUserTagDownload && !isEditing" @click.prevent="captureUserTag">
              <i class="fas fa-arrow-circle-down" style="margin-right: 6px"></i>
              {{ $t('userProfile.buttons.downloadBadge') }}
            </button>

            <!-- NAME -->
            <label class="userProfile-inputs-label" for="name" v-if="profileConfig.field.name.enable">{{ profileConfig.field.name.placeholder }}</label>
            <input
              :disabled="profileConfig.field.name.locked || !isEditing"
              class="userProfile-field-input"
              v-if="profileConfig.field.name.enable"
              id="name"
              type="field"
              v-model="user.name"
              @keydown.esc="user.name = ''"
              @keypress.enter="saveUserProfile" />

            <!-- NICKNAME -->
            <label class="userProfile-inputs-label" for="name" v-if="profileConfig.field.nickname.enable">{{ profileConfig.field.nickname.placeholder }}</label>
            <input class="userProfile-field-input" v-if="profileConfig.field.nickname.enable" id="name" type="field" v-model="user.nickname" :disabled="!isEditing" @keydown.esc="user.nickname = ''" @keypress.enter="saveUserProfile" />

            <!-- COMAPNY -->
            <label class="userProfile-inputs-label" for="company" v-if="profileConfig.field.company.enable">{{ profileConfig.field.company.placeholder }}</label>
            <input
              :disabled="profileConfig.field.company.locked || !isEditing"
              class="userProfile-field-input"
              v-if="profileConfig.field.company.enable"
              id="company"
              type="field"
              v-model="user.company"
              @keydown.esc="user.company = ''"
              @keypress.enter="saveUserProfile" />

            <!-- ROLE -->
            <label class="userProfile-inputs-label" for="role" v-if="profileConfig.field.role.enable">{{ profileConfig.field.role.placeholder }}</label>
            <input
              :disabled="profileConfig.field.role.locked || !isEditing"
              class="userProfile-field-input"
              v-if="profileConfig.field.role.enable"
              id="role"
              type="field"
              v-model="user.role"
              @keydown.esc="user.role = ''"
              @keypress.enter="saveUserProfile" />

            <!-- CODE -->
            <label class="userProfile-inputs-label" for="code" v-if="profileConfig.field.other.code && profileConfig.field.other.code.enable">{{ profileConfig.field.other.code.placeholder }}</label>
            <input disabled class="userProfile-field-input" v-if="profileConfig.field.other.code && profileConfig.field.other.code.enable" id="code" type="field" v-model="user.other.code" @keypress.enter="saveUserProfile" />

            <!-- CITY -->
            <label class="userProfile-inputs-label" for="name" v-if="profileConfig.field.other.city && profileConfig.field.other.city.enable">{{ profileConfig.field.other.city.placeholder }}</label>
            <input
              :disabled="profileConfig.field.other.city.locked || !isEditing"
              class="userProfile-field-input"
              v-if="profileConfig.field.other.city && profileConfig.field.other.city.enable"
              id="name"
              type="field"
              v-model="user.other.city"
              @keypress.enter="saveUserProfile" />

            <!-- STATE_CODE -->
            <label class="userProfile-inputs-label" for="name" v-if="profileConfig.field.state_code.enable">{{ profileConfig.field.state_code.placeholder }}</label>
            <input
              :disabled="profileConfig.field.state_code.locked || !isEditing"
              class="userProfile-field-input"
              v-if="profileConfig.field.state_code.enable"
              id="name"
              type="field"
              v-model="user.state_code"
              @keypress.enter="saveUserProfile" />

            <!-- SECTOR -->
            <label class="userProfile-inputs-label" for="sector" v-if="profileConfig.field.other.sector && profileConfig.field.other.sector.enable">{{ profileConfig.field.sector.placeholder }}</label>
            <input disabled class="userProfile-field-input" v-if="profileConfig.field.other.sector && profileConfig.field.other.sector.enable" id="sector" type="field" v-model="user.other.sector" @keypress.enter="saveUserProfile" />

            <!-- EMAIL -->
            <label class="userProfile-inputs-label" for="email" v-if="profileConfig.field.email.enable">{{ profileConfig.field.email.placeholder }}</label>
            <input disabled class="userProfile-field-input" v-if="profileConfig.field.email.enable" id="email" type="field" v-model="user.email" @keydown.esc="user.email = ''" @keypress.enter="saveUserProfile" />

            <!-- OPT_IN -->
            <label id="bottomOptions" class="userProfile-inputs-label" for="opt_in" v-if="profileConfig.field.opt_in && profileConfig.field.opt_in.enable && !isEditing">
              <input class="" v-if="profileConfig.field.opt_in && profileConfig.field.opt_in.enable" id="opt_in" type="checkbox" v-model="user.opt_in" />
              {{ profileConfig.field.opt_in.placeholder }}
            </label>

            <!-- FORGET ME -->
            <div id="forgetMe" class="forget-me-container" v-if="isEditing">
              <button class="btn-alt forgetMeBtn" @click="forgetUser">{{ $t('userProfile.buttons.deleteAccount') }}</button>
            </div>
          </div>
        </div>
        <div class="user-description" v-if="profileConfig.field.about_me.enable">
          <label class="userProfile-inputs-label" for="aboutMe">{{ profileConfig.field.about_me.placeholder }}</label>
          <textarea class="description-textarea" v-if="profileConfig.field.about_me.enable" id="aboutMe" type="field" v-model="user.about_me" :disabled="!isEditing" />
        </div>
        <div class="userProfile-other" v-if="createUser || user.firstLogin == user.lastLogin">
          <!-- <div :class="{'bottom-terms':!shakeAgree, 'bottom-terms shakeAnimation':shakeAgree}" style="padding-left: 20px">              
            <input class="login-forgot-password" type="checkbox" v-model="agree"><span class="userProfile-other-text" v-html="profileConfig.agreeText"></span>
            <div class="userProfile-other" v-for="(otherItem,key) in profileConfig.field.other" :key="key">
              <input :type="otherItem.fieldType" :name="otherItem.fieldName" :value="otherItem.value" v-model="otherItem.value"/>&nbsp;<span class="userProfile-other-text" v-html="otherItem.placeholder"></span>
            </div>
          </div> -->
        </div>
        <div id="profileBtns" class="userProfile-buttons" v-if="isEditing">
          <button class="user-profile-btn" @click="cancelEdit">
            <p>{{ $t('userProfile.buttons.cancel') }}</p>
          </button>
          <button class="user-profile-btn" @click="saveUserProfile">
            <p>{{ $t('userProfile.buttons.save') }}</p>
          </button>
        </div>

        <Banner
          class="user-panel-bottom-banner"
          :bannerSlot="'profile_bottom_banner'"
          :alignItems="'flex-end'"
          :maxWidth="'100%'"
          :maxHeight="'150px'"
          :borderRadius="userProfile.borderRadius"
          @enableBanner="showBanner = true"
          @disableBanner="showBanner = false"
          v-if="$store.state.template.banners.enableBanners" />

        <div id="userPanelBottom" class="user-panel-bottom-container" :style="{ display: showBanner ? 'none' : 'flex' }" v-if="!$store.state.template.banners.enableBanners">
          <img :src="`${this.$store.state.template.userProfile.bottomImage}`" />
        </div>
      </div>

      <!-- ANNOUNCEMENTS -->
      <div class="gamification-announcements-container" v-if="userProfile.showAnnouncements" v-html="userProfile.announcementsHtml"></div>
      <!-- GAMIFICATION -->
      <div class="gamerProfile-points-container" :style="{ color: userProfile.textColor }" v-if="showGamification">
        <div class="gamerProfile-points-item">
          <div class="gamerProfile-points-display" style="font-weight: bolder">{{ myRank }}</div>
          <span style="opacity: 0.5">{{ $t('userProfile.gamification.ranking') }}</span>
        </div>
        <div class="gamerProfile-points-item" v-for="(score, key) in scores" :key="key">
          <div class="gamerProfile-points-display" style="font-weight: bolder">{{ abbreviateNumber(score.points) }}</div>
          <span style="opacity: 0.5">{{ $t('userProfile.gamification.points') }}</span>
        </div>
      </div>
      <div class="gamerProfile-scores-container" style="width: 90%" v-if="showGamification">
        <div class="gamerProfile-highscore-wrapper">
          <span class="gamerProfile-highscore-title" :style="{ color: userProfile.textColor }">{{ $t('userProfile.gamification.leaderboard') }}</span>
          <div class="gamerProfile-highscore-container" :style="{ color: userProfile.textColor }">
            <div class="gamerProfile-highscore" v-for="(user, key) in leaderboard" :key="key">
              <div class="gamerProfile-highscore-entry">
                <span>
                  <span style="opacity: 0.6">{{ `${key + 1} - ` }}</span>
                  <span>{{ `${user.name}` }}</span>
                </span>
                <span style="margin-left: 10px">
                  {{ ` ${abbreviateNumber(user.points)}` }}
                  <span style="opacity: 0.5; font-size: 0.9rem">{{ $t('userProfile.gamification.pts') }}</span>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="gamerProfile-activities-wrapper">
          <span class="gamerProfile-activities-title" :style="{ color: userProfile.textColor }">{{ $t('userProfile.gamification.yourActivities') }}</span>
          <div class="gamerProfile-activities-container" :style="{ color: userProfile.textColor }">
            <div class="gamerProfile-activities" v-for="(activity, key) in activitiesLog" :key="key">
              <div class="">
                {{ `${activity.description}  ` }}
                <span style="font-weight: bolder; font-size: 1.2rem">{{ `${abbreviateNumber(activity.point)}` }}</span>
                <span style="opacity: 0.5">{{ $t('userProfile.gamification.pts') }}</span>
                <br />
                <div style="opacity: 0.5">{{ dateFormatHandler(activity.created_at) }}</div>
              </div>
            </div>
            <div class="gamerProfile-activities" style="cursor: pointer" @click.prevent="loadMoreResults" v-if="showLoadMoreResults">{{ $t('userProfile.gamification.seeMore') }}</div>
          </div>
        </div>
      </div>

      <!-- SCHEDULE -->
      <UserSchedule style="margin-bottom: 40px" v-if="accessConfig.enablePersonalAgenda" />

      <div class="feed-container-embed-full" v-if="showFeed">
        <Feed :userIsAdmin="false" />
      </div>
    </div>
    <ImageCropper
      ref="imageCropper"
      :key="imageCropperKey"
      v-if="showImageCropper"
      :src="imgSrc"
      @cancelCrop="restoreOldPic"
      @okCrop="
        showImageCropper = false;
        uploadImage;
      "
      @croppedUrl="croppedUrlHandler" />

    <div class="footer-wrapper">
      <Footer />
    </div>
    <Spinner :showSpinner="showSpinner" />
  </section>
</template>
<script>
import Header from '@/components/general/Header.vue';
import Footer from '@/components/general/Footer.vue';
import UserSchedule from '@/components/general/UserSchedule.vue';
import api from '@/services/api';
import * as dayjs from 'dayjs';
import ImageCropper from '@/components/general/ImageCropper.vue';
import Feed from '../components/user_content/Feed.vue';
import Banner from '@/components/banners/Banner.vue';
import * as html2canvas from '@/services/html2canvas';
import Spinner from '@/components/ui/Spinner.vue';

export default {
  name: 'UserProfile',

  components: { Header, Footer, Spinner, ImageCropper, Feed, UserSchedule, Banner },
  data() {
    return {
      dayjs: null,
      showGamification: false,
      showFeed: false,
      imageCropperKey: 0,
      imgSrc:
        'https://images.squarespace-cdn.com/content/v1/583a6a85893fc0a390c3a288/1555547935956-H8SVCMU7JH9HRKOK5P2C/ke17ZwdGBToddI8pDm48kAD-r7j4YN7tv4midO0oeTl7gQa3H78H3Y0txjaiv_0fDoOvxcdMmMKkDsyUqMSsMWxHk725yiiHCCLfrh8O1z4YTzHvnKhyp6Da-NYroOW3ZGjoBKy3azqku80C789l0prfa1Z6IeUrCPboCAmmHZmqcVosbeIW7EPiNy517darchQ3_FWKtlkzmpwe5AHLOA/home-page-hero%402x.jpg?format=2500w',
      showImgBtns: true,
      selectedFile: null,
      showProgressBar: false,
      showImageCropper: false,
      barWidth: '0%',
      user: { other: {}, opt_in: false },
      sector: '',
      agree: true,
      buyer: false,
      shakeAgree: false,
      oldUser: {},
      isEditing: false,
      accessConfig: {
        firstPage: '',
        firstPageParams: {},
      },
      profileConfig: {},
      createUser: false,
      userProfile: {},
      leaderboard: [],
      activitiesLog: [],
      scores: [],
      myRank: `50+`,
      currentResultsPage: 0,
      showLoadMoreResults: true,
      agenda: [],
      showBanner: false,
      userTagOutput: null,
      showSpinner: false,
      openAvatarList: false,
    };
  },
  methods: {
    startEdit() {
      this.isEditing = true;
      // Store original values in case user cancels
      this.oldUser = JSON.parse(JSON.stringify(this.user));
    },
    cancelEdit() {
      this.isEditing = false;
      // Restore original values
      this.user = JSON.parse(JSON.stringify(this.oldUser));
    },
    restoreOldPic() {
      this.showImageCropper = false;
      this.user.picture = this.oldUser.picture;
    },
    dataURItoBlob(dataURI) {
      let byteString = atob(dataURI.split(',')[1]);
      let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
      let ab = new ArrayBuffer(byteString.length);
      let ia = new Uint8Array(ab);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      let blob = new Blob([ab], { type: mimeString });
      blob.name = 'cropped.jpg';

      return blob;
    },
    prepareImageFile(theBlob, fileName) {
      theBlob.lastModifiedDate = new Date();
      theBlob.name = fileName;

      let downloadLink = document.createElement('a');
      downloadLink.setAttribute('download', 'user-image.jpg');
      let url = URL.createObjectURL(theBlob);
      downloadLink.setAttribute('href', url);
      downloadLink.click();
      this.selectedFile = theBlob;
      return theBlob;
    },
    croppedUrlHandler(croppedUrl) {
      this.user.picture = croppedUrl;
      // console.log('croppedurl: ' + JSON.stringify(croppedUrl));
      this.selectedFile = this.dataURItoBlob(croppedUrl);
      this.uploadImage();
      // console.log('selected file: ' + this.selectedFile);
    },
    checkEnterPress(key) {
      //console.log('KEY PRESS');
      if (key.keyCode == 13) this.saveUserProfile();
      if (key.keyCode == 27) this.resetInputs();
    },
    resetInputs() {
      //this.user = this.oldUser;
      //this.showImgBtns = true;
      // this.$router.go().catch(err => console.error('navigation error', err));

      // go back to previous page
      this.$router.back();
    },
    saveUserProfile() {
      // console.log('other: ' + JSON.stringify(this.profileConfig.field.other));
      if (!this.user.other) this.user.other = {};
      // this.user.other.sector = this.sector;
      api
        .put(`event/${this.$store.state.eventId}/user/${this.$store.state.user.id}`, {
          name: this.user.name,
          image: this.user.picture,
          //email: this.user.email,
          company: this.user.company,
          role: this.user.role,
          about_me: this.user.about_me,
          cpf: this.user.cpf,
          generate_password: this.user.generate_password,
          nickname: this.user.nickname,
          gender: this.user.gender,
          date_of_birth: this.user.date_of_birth,
          telephone: this.user.telephone,
          cep: this.user.cep,
          street: this.user.street,
          number: this.user.number,
          complement: this.user.complement,
          neighborhood: this.user.neighborhood,
          city_id: this.user.city_id,
          state_code: this.user.state_code,
          country_code: this.user.country_code,
          language_code: this.user.language_code,
          timezone: this.user.timezone,
          other: JSON.stringify(this.user.other),
          opt_in: this.user.opt_in,
        })
        .then((response) => {
          // console.log('Profile updated', response.config.data);
          if (response) {
            // Exit edit mode after successful save
            this.isEditing = false;

            // console.log('save profile user responsedata: ' + response.config);
            let data = response.config.data;
            let name = JSON.parse(data).name;
            let nickname = JSON.parse(data).nickname;
            let email = JSON.parse(data).email;
            let picture = JSON.parse(data).image;
            // console.log('save profile user data: ' + name);
            this.$store.commit('setUserName', name ? name : this.$store.state.user.name);
            this.$store.commit('setUserEmail', email ? email : this.$store.state.user.email);
            if (nickname) this.$store.commit('setUserNickname', nickname);
            if (picture) this.$store.commit('setUserPicture', picture);

            // ROUTE AFTER SAVE
            if (this.profileConfig.pageAfterUserProfile) {
              if (this.profileConfig.pageAfterUserProfile.name == 'UserProfile') this.$router.go();
              else this.$router.push(this.profileConfig.pageAfterUserProfile);
            } else if (this.accessConfig.firstPage) this.$router.push({ name: this.accessConfig.firstPage, params: this.accessConfig.firstPageParams.stream ? this.accessConfig.firstPageParams : { stream: '' } });
            else this.$router.back();
          }
        })
        .catch((err) => console.error(err));
    },
    forgetUser() {
      this.$modal.show('dialog', {
        title: this.$t('userProfile.dialog.attention'),
        text: this.$t('userProfile.dialog.deleteConfirmation'),
        buttons: [
          {
            title: this.$t('userProfile.dialog.yes'),
            handler: () => {
              api
                .post(`sessionAction/`, {
                  action: 'Forget User',
                  properties: JSON.stringify({ user_name: this.$store.state.user.name }),
                  userid: this.$store.state.user.id,
                  sessionid: this.$store.state.user.token,
                  event_id: this.$store.state.eventId,
                })
                .then((r) => {
                  api
                    .delete(`event/${this.$store.state.eventId}/user-forget/${this.$store.state.user.id}`)
                    .then((response) => {
                      this.$store.commit('resetUser');
                      this.$modal.hide('dialog');
                      this.$router.push({ name: 'Register' });
                    })
                    .catch((err) => console.error(err));
                })
                .catch((err) => console.error(err));
            },
          },
          {
            title: this.$t('userProfile.dialog.no'),
            handler: () => {
              this.$modal.hide('dialog');
            },
          },
        ],
      });
    },
    imgFilePicked(event) {
      this.selectedFile = event.target.files[0];
      // console.log('selectedFile:', this.selectedFile.size / 1024 / 1024);
      let fileSize = parseInt(this.selectedFile.size / 1024 / 1024);
      // console.log('fileSize:', fileSize);

      // ACCEPTED FILE EXTENSIONS SMALLER THAN 3MB
      if (
        fileSize < 3 &&
        (this.selectedFile.name.endsWith('.jpg') ||
          this.selectedFile.name.endsWith('.JPG') ||
          this.selectedFile.name.endsWith('.jpeg') ||
          this.selectedFile.name.endsWith('.JPEG') ||
          this.selectedFile.name.endsWith('.png') ||
          this.selectedFile.name.endsWith('.PNG'))
      ) {
        this.showImgBtns = false;
        this.user.picture = URL.createObjectURL(event.target.files[0]);
        this.imgSrc = URL.createObjectURL(event.target.files[0]);
        this.imageCropperKey++;
        this.showImageCropper = true;
        this.showImgBtns = true;
        // console.log('FILE CHANGED: ' + this.selectedFile);
      } else alert(this.$t('userProfile.alerts.selectValidImage'));
    },
    onCancel() {
      // console.log(this.oldUser.picture);
      // this.user.picture = this.oldUser.picture;
      this.showImgBtns = true;
    },
    uploadImage() {
      this.showProgressBar = true;

      //console.log('ON UPLOAD');
      const formData = new FormData();
      formData.append('file', this.selectedFile);
      api
        .post(`event/${this.$store.state.eventId}/materialUpload`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: (progressEvent) => {
            // console.log('progress: ' + Math.round((progressEvent.loaded / progressEvent.total) * 100) + '%');
            this.barWidth = Math.round((progressEvent.loaded / progressEvent.total) * 100) + '%';
            if (progressEvent.loaded === progressEvent.total) {
              this.showImgBtns = true;
              this.showProgressBar = false;
            }
          },
        })
        .then((response) => {
          //console.log('file upload', response);
          if (response.data) {
            this.user.picture = response.data.url;
            api.post(`sessionAction/`, {
              action: 'Profile image upload',
              properties: JSON.stringify({ route: this.$route.name, params: this.$route.params }),
              userid: this.$store.state.user.id,
              sessionid: this.$store.state.user.token,
              event_id: this.$store.state.eventId,
            });
          }
        })
        .catch((err) => console.error(err));
    },
    loadValues() {
      if (this.$store.state.user.id) {
        try {
          api
            .get(`event/${this.$store.state.eventId}/user/${this.$store.state.user.id}`)
            .then((response) => {
              // console.log('User= ', response.data);
              if (response.data) {
                // console.log('Response Data =', response.data);
                this.user = {
                  key: response.data.user_id,
                  picture: response.data.image ? response.data.image : require('@/assets/img/default_avatar.png'),
                  name: response.data.name,
                  nickname: response.data.nickname,
                  company: response.data.company,
                  role: response.data.role,
                  email: response.data.email,
                  about_me: response.data.about_me,
                  state_code: response.data.state_code,
                  firstLogin: response.data.first_login,
                  lastLogin: response.data.last_login,
                  other: response.data.other ? JSON.parse(response.data.other) : {},
                  opt_in: response.data.opt_in,
                };
                this.oldUser = JSON.parse(JSON.stringify(this.user));
              }
            })
            .catch((err) => console.error(err));
        } catch (error) {
          console.error(error);
        }
        this.createUser = false;
      } else {
        if (accessConfig.publicSignIn) {
          //Must create user
          this.createUser = true;
        } else {
          //Error
          this.createUser = false;
        }
      }
    },
    loadGamificationResult() {
      api
        .get(`event/${this.$store.state.eventId}/gamificationResult`)
        .then((response) => {
          //console.log('gamificationResult', { response });
          this.scores.push(response.data);
        })
        .catch((err) => console.error(err));
    },
    getGamififactionRanking() {
      api
        .get(`event/${this.$store.state.eventId}/gamificationRanking`)
        .then((response) => {
          //console.log('ranking', { response });
          this.leaderboard = response.data;
          this.leaderboard.map((user, i) => {
            i++;
            if (user.user_id == this.$store.state.user.id) {
              // console.log({ user });
              // console.log(i);
              this.myRank = `${i}º`;
              if (i > 50) this.myRank = `50+`;
            }
            user.name = user.nickname ? user.nickname : user.name ? user.name : user.email ? user.email.split('@')[0] : 'Anônimo';
          });
        })
        .catch((err) => console.error(err));
    },
    getGamificationResultLog() {
      api
        .get(`event/${this.$store.state.eventId}/gamificationResultLog?limit=100&page=${this.currentResultsPage}`)
        .then((response) => {
          let pageLenght = response.data.filter(() => true).length;
          if (pageLenght < 100) {
            this.showLoadMoreResults = false;
          }
          this.currentResultsPage += 100;
          // console.log('log', { response });
          this.activitiesLog = response.data;
        })
        .catch((err) => console.error(err));
    },
    getGamificationLevelLog() {
      api
        .get(`event/${this.$store.state.eventId}/gamificationLevelLog?limit=10000`)
        .then((response) => {
          // console.log('gamificationLevelLog:', { response });
        })
        .catch((err) => console.error(err));
    },
    loadMoreResults() {
      if (this.showLoadMoreResults) {
        api
          .get(`event/${this.$store.state.eventId}/gamificationResultLog?limit=100&page=${this.currentResultsPage++}`)
          .then((response) => {
            // console.log('log', { response });
            let pageLenght = response.data.filter(() => true).length;
            response.data.map((item) => {
              this.activitiesLog.push(item);
            });
            if (pageLenght < 100) {
              this.showLoadMoreResults = false;
            }
            this.currentResultsPage += 100;
          })
          .catch((err) => console.error(err));
      }
    },
    dateFormatHandler(timestamp) {
      // console.log('timestamp: ' + timestamp);
      let messageDate = dayjs(timestamp);
      let midnight = new Date();
      midnight.setHours(0, 0, 0, 0);
      let hoursDiff = messageDate.diff(midnight, 'hour');
      // console.log({ hoursDiff });
      let dateDiff = messageDate.diff(dayjs(Date.now()), 'day');
      // console.log('messageDate: ' + dayjs(messageDate).format('DD/MM HH:mm') + ' - dateDiff: ' + dateDiff);
      if (dateDiff == 0 && hoursDiff >= 0) {
        return this.$t('dateFormat.todayAt', { time: dayjs(timestamp).format('HH:mm') });
      } else if (dateDiff == 0 && hoursDiff < 0) {
        return this.$t('dateFormat.yesterdayAt', { time: dayjs(timestamp).format('HH:mm') });
      } else if (dateDiff == -1) {
        return this.$t('dateFormat.yesterdayAt', { time: dayjs(timestamp).format('HH:mm') });
      } else return this.$t('dateFormat.dayAt', { date: dayjs(timestamp).format('DD/MM'), time: dayjs(timestamp).format('HH:mm') });
    },
    abbreviateNumber(number) {
      //console.log('Number =' , number)
      const SI_SYMBOL = ['', 'k', 'M', 'G', 'T', 'P', 'E'];
      // what tier? (determines SI symbol)
      let tier = (Math.log10(Math.abs(number)) / 3) | 0;

      // if zero, we don't need a suffix
      if (tier < 2) return Number(number).toLocaleString();

      // get suffix and determine scale
      let suffix = SI_SYMBOL[tier];
      let scale = Math.pow(10, tier * 3);

      // scale the number
      let scaled = number / scale;

      // format number and add suffix
      return scaled.toFixed(1) + suffix;
    },
    async captureUserTag() {
      this.showSpinner = true;
      document.getElementById('usertagDownloadBtn').style.display = 'none';
      if (document.getElementById('bottomOptions')) document.getElementById('bottomOptions').style.display = 'none';
      if (document.getElementById('profileBtns')) document.getElementById('profileBtns').style.display = 'none';
      if (document.getElementById('forgetMe')) document.getElementById('forgetMe').style.display = 'none';
      if (document.getElementById('chose-photo-btn')) document.getElementById('chose-photo-btn').style.display = 'none';
      if (document.getElementById('chose-avatar-btn')) document.getElementById('chose-avatar-btn').style.display = 'none';

      const el = this.$refs.userTag;
      // console.log(el);

      const options = {
        type: 'dataURL',
        useCORS: true,
        allowTaint: false,
        logging: false,
        backgroundColor: 'transparent',
      };

      this.userTagOutput = await html2canvas(el, options);
      let a = document.createElement('a');

      a.href = this.userTagOutput.toDataURL();
      a.download = `${this.$store.state.user.name}.png`;
      a.click();

      document.getElementById('usertagDownloadBtn').style.display = 'flex';
      if (document.getElementById('bottomOptions')) document.getElementById('bottomOptions').style.display = 'block';
      if (document.getElementById('profileBtns')) document.getElementById('profileBtns').style.display = 'flex';
      if (document.getElementById('forgetMe')) document.getElementById('forgetMe').style.display = 'flex';
      if (document.getElementById('chose-photo-btn')) document.getElementById('chose-photo-btn').style.display = 'flex';
      if (document.getElementById('chose-avatar-btn')) document.getElementById('chose-avatar-btn').style.display = 'flex';
      this.showSpinner = false;
    },
    subscribe(e) {
      // console.log('subscribe', { e });
      try {
        let data = JSON.parse(e.data);
        if (data.eventName === 'rendered') {
          // this.user.picture = data.image;
          this.openAvatarList = false;

          this.imgSrc = data.image;
          this.$nextTick(() => {
            this.showImageCropper = true;
          });
        }
      } catch (err) {}
    },
  },
  beforeMount() {
    this.accessConfig = this.$store.state.template.accessConfig;
    this.profileConfig = this.$store.state.template.profileConfig;
    this.userProfile = this.$store.state.template.userProfile;
    this.loadValues();
    this.showGamification = (this.$store.state.template.gamification ? this.$store.state.template.gamification : false) && (this.$store.state.template.showGamificationRanking ? this.$store.state.template.showGamificationRanking : false);
    this.loadGamificationResult();
    this.getGamififactionRanking();
    this.getGamificationResultLog();
    this.getGamificationLevelLog();
  },
  mounted() {
    window.addEventListener('message', this.subscribe);
  },
  beforeDestroy() {
    window.removeEventListener('message', this.subscribe);
  },
};
</script>

<style lang="scss">
.userProfile {
  position: relative;
  background-color: var(--main-color);
  background-position: center;
  background-size: cover;
  background-attachment: fixed;
  background-repeat: repeat-y;
  width: 100%;
  height: 100%;
  height: 100dvh;
  overflow-y: auto;
}
.footer-wrapper {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 10;
}
.userProfile-wrapper {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  min-height: 96.8dvh;
  padding-bottom: 80px;
  padding-top: 140px;
  @media (max-height: 460px) {
    padding-top: 72px;
  }
  @include media('<=phone') {
    padding-top: 72px;
  }
}
.userProfile-background-img {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  // height: 100%;
  z-index: 0;
}
.userProfile-first-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 55%;
  z-index: 1;
  height: 100%;
  // padding-top: 80px;
}
.userProfile-eventLogo-internal {
  img {
    // width: auto;
    max-height: 30vh;
  }
}
.userProfile-second-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  min-width: 40%;
  height: 100%;
  z-index: 1;
  padding: 5%;
  // margin-top: 100px;
}
.userProfile-title {
  // align-self: center;
  margin: 2% 0 2% 0;
  // width: 118px;
  // border-bottom: 1px solid white;
  h1 {
    font-size: 32px;
    letter-spacing: 2px;
    text-align: center;
    margin-bottom: 0;
  }
}
.feed-container-embed-full {
  width: 80%;
}
.forget-me-container {
  position: absolute;
  right: 0;
  bottom: 0;
  opacity: 0.7;
  z-index: 1;

  @include media('<=tablet') {
    top: 4px;
    bottom: auto;
  }

  .forgetMeBtn {
    cursor: pointer;
    font-size: 0.7rem;
    color: var(--userProfile-textColor);
    background: none;
    border: 1px solid var(--userProfile-textColor);
  }
}
.panel-usertag-download-btn {
  position: absolute;
  right: 4px;
  top: 4px;
  margin-left: auto;
  border: none;
  cursor: pointer;
  background: none;
  color: #555;
  color: var(--userProfile-textColor);
  display: flex;
  align-items: center;
  opacity: 0.6;
  z-index: 1;
}
.user-panel {
  position: relative;
  width: 720px;
  margin: 20px 0;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.2);
  border-radius: var(--userProfile-borderRadius);
  background: var(--userProfile-bottomBgColor);

  @include media('<=phone-plus') {
  }

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.user-panel-top-container {
  max-width: 100%;
  min-height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--userProfile-topBgColor);
  border-top-left-radius: var(--userProfile-borderRadius);
  border-top-right-radius: var(--userProfile-borderRadius);

  img {
    max-width: 100%;
  }
}
.user-panel-bottom-container,
.user-panel-bottom-banner {
  width: 100%;
  min-height: 30px;
  background: var(--userProfile-bottomBgColor);
  border-bottom-left-radius: var(--userProfile-borderRadius);
  border-bottom-right-radius: var(--userProfile-borderRadius);

  display: flex;
  align-items: center;
  justify-content: center;

  img {
    max-width: 100%;
  }
}
.user-panel-bottom-banner {
  .banner-img {
    object-fit: contain;
    object-position: bottom;
  }
}
.user-image-and-fields {
  // background-color: darkgrey;
  position: relative;
  display: flex;
  // border-radius: var(--userProfile-borderRadius);
  padding: 1% 2%;
  background: var(--userProfile-middleBgColor);

  .user-image-uploader {
    position: relative;
    font-size: 0.8rem;
    width: 100%;
    max-height: 20%;
    z-index: 1;
    cursor: pointer;
    display: flex;
    justify-content: center;

    .image-uploader-chose-file-btn,
    .image-uploader-chose-avatar-btn {
      position: absolute;
      top: -46px;
      left: 10px;
      text-decoration: underline;
      background: var(--userProfile-buttonBgColor);
      opacity: 0.73;
      padding: 6px;
      border-radius: 50%;
      &:hover {
        filter: brightness(1.08);
      }

      i {
        font-size: 1rem;
        color: var(--userProfile-buttonTextColor);
      }
    }
    .image-uploader-chose-avatar-btn {
      top: -46;
      left: unset;
      right: 10px;
    }
    .image-uploader-cancel-btn {
      cursor: pointer;
      border: none;
      height: 36px;
      padding: 8px;
      color: var(--button-background);
      border: 2px solid var(--button-background);
      margin-right: 5px;
    }
    .image-uploader-ok-btn {
      cursor: pointer;
      border: none;
      height: 36px;
      padding: 10px;
      color: var(--button-text);
      background-color: var(--button-background);
      margin-left: 5px;
    }
    .progressbar-container {
      background-color: var(--main-color);
      height: 8px;
      width: 60%;
    }
    .progressbar {
      background-color: teal;
      height: 8px;
      width: 20%;
    }
  }

  .user-fields-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0 5%;
    &:last-child {
      margin-bottom: 6px;
    }

    .edit-profile-btn {
      position: absolute;
      top: 0;
      right: 10px;
      padding: 6px;
      color: var(--userProfile-textColor);
      background: transparent;
      border: none;
      font-size: 0.7rem;
      opacity: 0.6;
      z-index: 1;
      cursor: pointer;
    }

    .edit-register-btn {
      position: absolute;
      top: 10px;
      right: 10px;
      font-size: 0.7rem;
      color: var(--userProfile-textColor);
      border: 1px solid var(--userProfile-textColor);
      padding: 6px;
      z-index: 1;
      cursor: pointer;
    }
    .userProfile-inputs-label {
      margin: 10px 0 4px 0;
      color: var(--userProfile-textColor);
      letter-spacing: 2px;
      opacity: 0.6;
    }
    .userProfile-field-input {
      font-size: var(--userProfile-textFontSize);
      color: var(--userProfile-textColor);
      padding: 1% 1% 1% 0;
      width: 100%;
      border: 0;
      outline: none;
      background-color: transparent;
    }
    .userProfile-field-input:focus {
      // display: none;
      // background-color: darkgray;
      color: var(--userProfile-textColor);
      background-color: transparent;
    }
    .userProfile-field-input::placeholder {
      /* Chrome, Firefox, Opera, Safari 10.1+ */
      color: var(--userProfile-textColor);
      opacity: 1; /* Firefox */
      font-size: 1.5rem;
      font-weight: 400;
    }
    .userProfile-field-input::-ms-input-placeholder {
      /* Microsoft Edge */
      color: var(--userProfile-textColor);
    }
  }
}
.user-image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 2.5% 2.5% 2.5% 0;
  gap: 10px;
  width: 35%;
  height: 100%;
}
.userProfile-user-picture-img {
  position: relative;
  object-fit: cover;
  object-position: center;
  // background-color: var(--button-background) !important;
  // width: 70%;
  width: 150px;
  height: 150px;
  // border: 4px solid var(--userProfile-buttonBgColor);
  border-radius: 50%;
  display: block;
}
.userProfile-other {
  width: 100%;
  padding: 1% 0;
  background: var(--userProfile-middleBgColor);
}
.userProfile-other-text {
  color: var(--userProfile-textColor);
  a {
    color: var(--userProfile-textColor);
    opacity: 0.7;
    text-decoration: underline;
  }
}
.user-description {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 15vh;
  background: var(--userProfile-middleBgColor);
  // width: 100%;
  padding: 0%;
  .description-textarea {
    position: relative;
    font-size: 1.4rem;
    color: var(--userProfile-textColor);
    padding: 1% 0;
    width: 100%;
    height: 100%;
    border: 0;
    border-bottom: 1px solid var(--userProfile-textColor);
    outline: none;
    background-color: transparent;
    overflow: visible;
    resize: none;
  }
}

.userProfile-buttons {
  position: relative;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 80px;
  padding: 0 2%;
  background: var(--userProfile-middleBgColor);

  .user-profile-btn {
    visibility: visible;
    &:hover {
      filter: brightness(1.08);
    }
    @include media('<=tablet') {
      visibility: visible;
    }
    cursor: pointer;
    border: none;
    outline: none;
    padding: 10px;

    color: var(--userProfile-buttonBgColor);
    border: 2px solid var(--userProfile-buttonBgColor);
    background: transparent;

    margin-top: 10px;
    border-radius: var(--userProfile-borderRadius);
    width: 100%;
    font-size: 1.1rem;
    &:last-child {
      margin-left: 15px;
      color: var(--userProfile-buttonTextColor);
      background-color: var(--userProfile-buttonBgColor);
      border: 2px solid var(--userProfile-buttonBgColor);
    }
  }
}
.user-panel:hover > .profile-buttons .user-profile-btn {
  visibility: visible;
}
.avatar-list-container {
  position: fixed;
  inset: 99px 0 0;
  z-index: 2;
  background: #222b;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    position: absolute;
    top: 10px;
    right: 1%;
  }

  .avatar-list {
    position: relative;
    // background: var(--userProfile-buttonBgColor);
    width: 100%;
    height: 100%;
    // margin-top: 99px;

    display: flex;
    align-items: center;
    justify-content: center;

    .avatarCreatorIframe {
      position: relative;
      width: 90vw;
      height: 100%;
      z-index: 1;
      margin-top: 50px;
    }
  }
  img {
    position: relative;
    margin: 4px;
    max-width: 60px;
    max-height: 60px;
    object-fit: contain;
    cursor: pointer;
  }
}

.gamification-announcements-container {
  margin: 50px 0;
  width: 60%;
  box-shadow: 0px 0px 22px 0 rgba(0, 0, 0, 0.2);
  border-radius: var(--userProfile-borderRadius);
  display: flex;
  justify-content: center;
  text-align: center;
  color: var(--userProfile-textColor);
  background: var(--userProfile-middleBgColor);
}
@include media('<=tablet') {
  .userProfile-first-container {
    width: 90%;
    min-height: 35%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .userProfile-eventLogo {
    img {
      width: auto;
      height: 50vh;
    }
  }
  .userProfile-second-container {
    justify-content: flex-start;
    padding-top: 2%;
    padding-bottom: 5%;
    width: 100%;
  }
  .user-panel {
    max-width: 76%;
  }
  .user-image-and-fields {
    flex-direction: column;
    align-items: center;
    .user-fields-wrapper {
      // align-items: center;

      .userProfile-field-input {
        // text-align: center;
        font-size: 1.3rem;
      }
    }
    #bottomOptions {
      text-align: left;
      align-self: flex-start;
    }
    .user-image-wrapper {
      width: 50%;
      // img {
      //   width: 18vw;
      //   height: 18vw;
      // }
    }
  }
  @include media('<=phone') {
    .user-panel {
      max-width: 90%;
    }
    .user-image-and-fields {
      flex-direction: column;
      align-items: center;
      // .user-image-wrapper {
      //   // width: auto;
      //   img {
      //     // width: 26vw;
      //     // height: 26vw;
      //   }
      // }
    }
  }
}

#bottomOptions {
  position: relative;
  @include media('<=phone-plus') {
    max-width: 60%;
  }
}
</style>
